import {ChangeDetectorRef, Component, Inject, OnDestroy, OnInit, Optional, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA} from "@angular/material/dialog";
import {AppService, StoreSelectorsService} from "../../../services";
import {Compbaser} from "../../../components/compbaser";
import {Id, IStationData} from "../../../interfaces";
import {StationSnapshotComponent} from "../station-snapshot/station-snapshot.component";
import {actionEnterpriseStationsStatusV1V2tReply} from "../../../store/actions/enterprise.actions";
import {ofType} from "@ngrx/effects";
import {ActionsSubject} from "@ngrx/store";
import {actionStationV1V2Update} from "../../../store/actions/user.actions";
import {fadeTransition, staggerTransitionInOut} from "../../../../libs/basicTransition";
import {isNullOrUndefOrEmpty} from "../../../common";

@Component({
    selector: 'app-station-live',
    templateUrl: './station-live.component.html',
    styleUrls: ['./station-live.component.scss'],
    animations: [
        fadeTransition,
        staggerTransitionInOut
    ]
})
export class StationLiveComponent extends Compbaser implements OnInit, OnDestroy {

    // m_statsTrackData = [
    //     {
    //         name: 'not connected',
    //         value: 0,
    //         extra: {
    //             code: ""
    //         }
    //     },
    //     {
    //         name: 'connected',
    //         value: 0,
    //         extra: {
    //             code: ""
    //         }
    //     },
    //     {
    //         name: 'polling',
    //         value: 0,
    //         extra: {
    //             code: ""
    //         }
    //     }
    // ];
    m_stationData: IStationData;
    m_loading = true;
    m_mapReady = false;
    m_loadingStation = true;
    m_snapStatus = false;
    m_waitingOnSnap = false;

    @ViewChild(StationSnapshotComponent, {static: false}) stationSnapshotComponent: StationSnapshotComponent;

    constructor(public storeSelector: StoreSelectorsService, @Optional() @Inject(MAT_DIALOG_DATA) data,
                private appService: AppService,
                private actionsSubj: ActionsSubject,
                public cdr: ChangeDetectorRef) {
        super();
        this.m_stationData = data.stationData;

        setTimeout(() => {
            this.m_loading = false;
            this.cdr.detectChanges();
        }, 2000);

        setTimeout(() => {
            this.m_mapReady = true;
            this.appService.syncStations();
            this.cdr.detectChanges();
        }, 5000);

        this.cod(
            actionsSubj.pipe(ofType(actionEnterpriseStationsStatusV1V2tReply))
                .subscribe((reply) => {
                    this.m_loadingStation = false;
                })
        );
        this.cod(
            actionsSubj.pipe(ofType(actionStationV1V2Update))
                .subscribe((reply) => {
                    this.m_loadingStation = false;
                })
        );
        // this.cod(
        //     this.storeSelector.getTrackStats().pipe(
        //         take(1),
        //         map(stations => {
        //             if (!stations || !isArray(stations)) {
        //                 return;
        //             }
        //             return stations.filter(a => {
        //                 if (!this.m_stationData) return false;
        //                 const stationBusinessId = concatIdBusinessId(a.station_id, a.business_id);
        //                 return stationBusinessId == this.m_stationData.stat.$.station_business_id;
        //             });
        //         })
        //     ).subscribe((v) => {
        //         if (!v) return;
        //         v.forEach((val) => {
        //             this.m_statsTrackData[val.connection]['value'] = this.m_statsTrackData[val.connection]['value'] + 1;
        //         });
        //     })
        // );
    }

    ngOnInit() {
        // actionEnterpriseSuccessE
        // actionLoadStationsSuccess
    }

    takeSnap() {
        let businessId: Id;
        if (!this.stationSnapshotComponent) return;
        if (this.m_stationData?.stat?.$?.businessId) {
            businessId = this.m_stationData.stat.$.businessId;
        } else if (this.m_stationData?.props?.station_business_id) {
            businessId = this.m_stationData.props.station_business_id;
            const match = businessId.match(/_(\d+)_/);
            if (match && match.length > 1) {
                businessId = match[1];
            }
        }
        if (isNullOrUndefOrEmpty(businessId))
            return;
        this.m_snapStatus = true;
        this.m_waitingOnSnap = true;
        setTimeout(() => {
            this.m_waitingOnSnap = false;
        }, 5000);
        this.stationSnapshotComponent.takeSnapshotUser(this.m_stationData, businessId, this.m_stationData?.props?.version);
    }
}

